import { render, staticRenderFns } from "./CustomCkEditor.vue?vue&type=template&id=37f3bad8"
import script from "./CustomCkEditor.vue?vue&type=script&lang=js"
export * from "./CustomCkEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomCkEditor.vue?vue&type=style&index=0&id=37f3bad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports